export default __webpack_public_path__ + "media/images/react_icons/checkbox-circle-fill-6d2c166f8beb590ebfe24a09136cefeb.svg";